import React from 'react';
import { MessageCircle } from 'lucide-react';

/**
 * "Continue as ..." smart card — shown when we recognise this device
 * from a previous successful auth (read from localStorage). Pure UI;
 * parent decides what to do on click.
 */
export const LastAuthCard = ({ lastAuth, onContinue, onClear, disabled }) => {
  if (!lastAuth) return null;
  return (
    <div className="mb-3" data-testid="last-auth-card">
      <button
        onClick={onContinue}
        disabled={disabled}
        data-testid="continue-as-last-btn"
        className="group w-full flex items-center gap-3 px-4 py-3.5 rounded-lg border-2 border-[#0F172A] bg-white hover:bg-slate-50 transition-colors text-left disabled:opacity-50"
      >
        {lastAuth.picture ? (
          <img
            src={lastAuth.picture}
            alt=""
            className="h-10 w-10 rounded-full object-cover ring-2 ring-[#D4AF37]"
          />
        ) : (
          <div
            className="h-10 w-10 rounded-full flex items-center justify-center ring-2 ring-[#D4AF37]"
            style={{
              background: lastAuth.method === 'whatsapp' ? '#25D366' : '#0F172A',
            }}
          >
            {lastAuth.method === 'whatsapp' ? (
              <MessageCircle className="h-5 w-5 text-white" />
            ) : (
              <span className="text-white text-xs font-bold">
                {(lastAuth.email || lastAuth.phone || '?').charAt(0).toUpperCase()}
              </span>
            )}
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div
            className="text-[10px] tracking-widest uppercase font-bold"
            style={{ color: '#D4AF37' }}
          >
            Continue as
          </div>
          <div className="text-sm font-semibold text-[#0F172A] truncate">
            {lastAuth.name || lastAuth.email || lastAuth.phone || 'this device'}
          </div>
          <div className="text-[11px] text-slate-500 truncate">
            {lastAuth.method === 'google' && lastAuth.email && lastAuth.email}
            {lastAuth.method === 'whatsapp' && '· WhatsApp'}
            {lastAuth.method === 'email' && '· Email'}
          </div>
        </div>
        <span className="text-xs text-slate-400 group-hover:text-[#0F172A] transition-colors">
          →
        </span>
      </button>
      <button
        onClick={onClear}
        data-testid="last-auth-clear"
        className="block w-full text-center text-[11px] text-slate-400 hover:text-slate-600 mt-2"
      >
        Use a different account
      </button>
    </div>
  );
};

export default LastAuthCard;
